import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SigninData, SigninStatus, SignInEvent } from './auth-types';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  readonly signinUrl: string = '/auth/signin.json';
  readonly otpUrl: string = '/auth/otp/';
  readonly logSignInEventUrl: string = '/auth/logSignInEvent.json';
  readonly resetPasswordUrl: string = '/auth/sendResetPassword.json';
  readonly checkPasswordResetTokenUrl: string = '/auth/checkPasswordResetToken.json';
  readonly changePasswordUsingResetUrl: string = '/auth/changePasswordUsingReset.json';

  constructor(private http: HttpClient) { }

  signin(data: SigninData): Observable<SigninStatus> {
    return this.http.post<SigninStatus>(this.signinUrl, data);
  }

  logSignInEvent(data: SignInEvent): Observable<any> {
    return this.http.post<SignInEvent>(this.logSignInEventUrl, data);
  }

  resetPassword(username: string): Observable<SigninStatus> {
    return this.http.post<SigninStatus>(this.resetPasswordUrl, {username: username});
  }

  checkPasswordResetToken(token: string): Observable<boolean> {
    return this.http.post<boolean>(this.checkPasswordResetTokenUrl, {token: token});
  }

  changePasswordUsingReset(token: string, password: string, networkId: number): Observable<SigninStatus> {
    return this.http.post<SigninStatus>(this.changePasswordUsingResetUrl, {token: token, password: password,networkId: networkId});
  }

  signinOtp(token: string) {
    return this.http.post<string>(this.otpUrl + token + '.json', {});
  }
}
